import React, { useEffect } from "react";
import { focusElemnt } from "./helper";
import { TickIcon } from "./icons/svg";

const AlertNew = ({
    msg,
    error = false,
    success = false,
    close,
    className = "",
    buttonText = "",
    checkfemale = "",
    handleClose,
    type,
}) => {
    let textInput = null;
    useEffect(() => {
        focusElemnt(`okayButton`);
    }, []);
    return (
        <div
            className="alert"
            onClick={handleClose ? handleClose : close}
            style={{ alignItems: "flex-start" }}
        >
            <div
                className={`alert--content${error ? " error" : ""}${success ? " success" : ""
                    } ${className}`}
                onClick={(e) => e.stopPropagation()}
                style={{
                    marginTop: "106px",
                    borderRadius: "0",
                    background: "#E0EFD8",
                    flexDirection: "column",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {success ? (
                    <TickIcon
                        style={{ background: "#3C763C", borderRadius: "50%", marginBottom: '15px' }}
                    />
                ) : (
                    ""
                )}
                {msg}
                {
                    <button
                        id={`okayButton`}
                        style={{
                            display: "block",
                            fontSize: "14px",
                            background: "#FF7100",
                            width: "unset",
                            margin: '15px',
                            cursor: 'pointer'
                        }}
                        ref={(button) => {
                            textInput = button;
                        }}
                        className="err-btn btn btn-primary"
                        onClick={() => close()}
                    >
                        {`${buttonText || "OK"}`}
                    </button>
                }
            </div>
        </div>
    );
};

export default AlertNew;
